import { List } from 'antd'
import KList from 'app/components/Modules/List/KList'
import KInfo from 'app/components/UI-Elements/DataDisplay/KInfo'
import { useQuery } from 'app/lib/hooks/useQuery'
import { queries } from 'app/queries'
import { upperFirst } from 'lodash'
import * as React from 'react'
import { ComponentProps } from 'react'

import { MemberProps } from '../../convention'

const AttributeSegmentationList: React.FC<
  MemberProps<Partial<ICategorySegment>, ComponentProps<typeof KList>>
> = ({ member, props }) => {
  const { data: response, loading } = useQuery<{
    categorySegment: ICategorySegment
  }>(queries.categorySegment.get, {
    variables: { id: member.id, includeAttributeSegmentations: true }
  })

  const displayValue = (item: IAttributeSegmentation) => {
    if (item.restrictionValues) {
      return item.restrictionValues.map((i) => upperFirst(i)).join(', ')
    } else {
      return `${item.restrictionMin} - ${item.restrictionMax} ${item.displayMetric}`
    }
  }

  return (
    <KList
      split={false}
      grid={{
        gutter: 16,
        column: 3,
        xs: 2
      }}
      renderItem={(item: IAttributeSegmentation) => (
        <List.Item>
          <KInfo
            title={upperFirst(item.descriptionShort || item.descriptionLong)}
            info={displayValue(item)}
          />
        </List.Item>
      )}
      dataSource={response?.categorySegment?.attributeSegmentations}
      loading={loading}
      {...props}
    />
  )
}

export default AttributeSegmentationList
